import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { ModalConfig } from '@df/ui/modal/modal-config';
export namespace NModalLayoutLeft {
    /**
     * Default setup for left side modal
     */
    export const ModalConfig: ModalConfig = {
        closeOnNavigation: true,
        height: '100vh',
        maxWidth: undefined,
        transformOptions: `translate3d(-100%, 0px, 0px)`,
        modalClass: 'p-a-0 bg-col-w modal-container-overflow-hidden',
        position: {
            top: '0',
            bottom: '0',
            left: '0'
        },
        transitionOptions: '500ms ease-in-out'
    };
    export const getWidth = (size: ISizeName): string => ({ S: StylesService.vw(89.3), M: StylesService.vw(74), L: StylesService.vw(33.82), X: '32.9rem' }[size]);
}
// @Component({
//     selector: 'modal-layout-left',
//     templateUrl: 'modal-layout-left.html',
//     styleUrls: ['modal-layout-left.scss']
// })
// export class ModalLayoutLeftComponent {}
